// This is an auto-generated file. Do not modify it manually.
import { default as awsAzurePeerings } from './aws-azure-peerings';
import { default as awsPeerings } from './aws-peerings';
import { default as awsQuickCreatePeerings } from './aws-quick-create-peerings';
import { default as azurePeeringsNoRoutes } from './azure-peerings-no-routes';
import { default as azurePeeringsZeroState } from './azure-peerings-zero-state';
import { default as azurePeerings } from './azure-peerings';
import { default as billingEntitlementFlexTransition } from './billing-entitlement-flex-transition';
import { default as billingEntitlementWithCreditCard } from './billing-entitlement-with-credit-card';
import { default as billingEntitlementZeroUsage } from './billing-entitlement-zero-usage';
import { default as billingEntitlement } from './billing-entitlement';
import { default as billingExpiredCreditCard } from './billing-expired-credit-card';
import { default as billingFlex100Projects } from './billing-flex-100-projects';
import { default as billingFlexAddOns } from './billing-flex-add-ons';
import { default as billingFlexContractExpiredDepletedNoRenewal } from './billing-flex-contract-expired-depleted-no-renewal';
import { default as billingFlexContractExpiredDepletedUpcomingRenewal } from './billing-flex-contract-expired-depleted-upcoming-renewal';
import { default as billingFlexContractExpiredUpcomingRenewal } from './billing-flex-contract-expired-upcoming-renewal';
import { default as billingFlexContractExpired } from './billing-flex-contract-expired';
import { default as billingFlexContractExpiringSoon } from './billing-flex-contract-expiring-soon';
import { default as billingFlexDepletedBalancePartialAddOn } from './billing-flex-depleted-balance-partial-add-on';
import { default as billingFlexFirstMonth } from './billing-flex-first-month';
import { default as billingFlexLowBalance } from './billing-flex-low-balance';
import { default as billingFlexRecentAddOns } from './billing-flex-recent-add-ons';
import { default as billingFlexRecentlyActivatedRenewalAndRecentAddons } from './billing-flex-recently-activated-renewal-and-recent-addons';
import { default as billingFlexRecentlyActivatedRenewal } from './billing-flex-recently-activated-renewal';
import { default as billingFlexUpcomingRenewalAndRecentAddons } from './billing-flex-upcoming-renewal-and-recent-addons';
import { default as billingFlexUpcomingRenewalDepletedBalance } from './billing-flex-upcoming-renewal-depleted-balance';
import { default as billingFlexUpcomingRenewal } from './billing-flex-upcoming-renewal';
import { default as billingFlexZeroBalance } from './billing-flex-zero-balance';
import { default as billingFlexZeroUsage } from './billing-flex-zero-usage';
import { default as billingFlex } from './billing-flex';
import { default as billingOnDemandFlexTransition } from './billing-on-demand-flex-transition';
import { default as billingOnDemandLowCredits } from './billing-on-demand-low-credits';
import { default as billingOnDemandZeroCredits } from './billing-on-demand-zero-credits';
import { default as billingOnDemandZeroUsage } from './billing-on-demand-zero-usage';
import { default as billingOnDemand } from './billing-on-demand';
import { default as billingTrialFlexTransition } from './billing-trial-flex-transition';
import { default as billingTrialLowCredits } from './billing-trial-low-credits';
import { default as billingTrialZeroCredits } from './billing-trial-zero-credits';
import { default as boundaryUpdatingClusterFailed } from './boundary-updating-cluster-failed';
import { default as boundaryUpdatingCluster } from './boundary-updating-cluster';
import { default as boundary } from './boundary';
import { default as consulAgentless } from './consul-agentless';
import { default as consulClusterPeering } from './consul-cluster-peering';
import { default as consulFederation } from './consul-federation';
import { default as consulSnapshots } from './consul-snapshots';
import { default as consulTrialActive } from './consul-trial-active';
import { default as consulTrialExpired } from './consul-trial-expired';
import { default as consulTrialIneligible } from './consul-trial-ineligible';
import { default as consulTrialQuotaReached } from './consul-trial-quota-reached';
import { default as consul } from './consul';
import { default as consulAzure } from './consulAzure';
import { default as consulClusterSizes } from './consulClusterSizes';
import { default as consulClusterTiers } from './consulClusterTiers';
import { default as consulDelinquent } from './consulDelinquent';
import { default as consulFcp } from './consulFcp';
import { default as consulGnm } from './consulGnm';
import { default as consulObservability } from './consulObservability';
import { default as consulObservabilityViewer } from './consulObservabilityViewer';
import { default as consulReadOnlyMode } from './consulReadOnlyMode';
import { default as consulViewer } from './consulViewer';
import { default as contributor } from './contributor';
import { default as defaultModule } from './default';
import { default as freshStart } from './fresh-start';
import { default as groupManagerEnabled } from './group-manager-enabled';
import { default as hashicorpSsoConfigured } from './hashicorp-sso-configured';
import { default as hogwarts } from './hogwarts';
import { default as hvnHvnFederatedPeeringNoDependencies } from './hvn-hvn-federated-peering-no-dependencies';
import { default as hvnHvnFederatedPeering } from './hvn-hvn-federated-peering';
import { default as logs } from './logs';
import { default as monitoring } from './monitoring';
import { default as multiHvnsAwsAndAzure } from './multi-hvns-aws-and-azure';
import { default as multiHvnsDifferentRegions } from './multi-hvns-different-regions';
import { default as multiHvnsUnsupportedRegions } from './multi-hvns-unsupported-regions';
import { default as multiHvns } from './multi-hvns';
import { default as navLongNames } from './nav-long-names';
import { default as networkConnectionsActive } from './network-connections-active';
import { default as networkConnectionsExpired } from './network-connections-expired';
import { default as networkConnectionsFailed } from './network-connections-failed';
import { default as networkConnectionsRejected } from './network-connections-rejected';
import { default as newUserWithoutInvite } from './new-user-without-invite';
import { default as noActiveSessions } from './no-active-sessions';
import { default as noBillingAccount } from './no-billing-account';
import { default as noOwnedOrgsNoCreditCard } from './no-owned-orgs-no-credit-card';
import { default as noOwnedOrgs } from './no-owned-orgs';
import { default as noRoleMultipleOrgs } from './no-role-multiple-orgs';
import { default as noRoleNoProjects } from './no-role-no-projects';
import { default as noRole } from './no-role';
import { default as noServicePrincipals } from './no-service-principals';
import { default as oidcSsoConfigured } from './oidc-sso-configured';
import { default as packerPlus } from './packer-plus';
import { default as packerViewer } from './packer-viewer';
import { default as packer } from './packer';
import { default as readonlyBillingPermissions } from './readonly-billing-permissions';
import { default as samlSsoConfigured } from './saml-sso-configured';
import { default as scimEnabled } from './scim-enabled';
import { default as secretsContributorPermissions } from './secrets-contributor-permissions';
import { default as secrets } from './secrets';
import { default as secretsPlusTier } from './secrets.plus-tier';
import { default as secretsStandardTier } from './secrets.standard-tier';
import { default as unifiedExperienceManyProjects } from './unified-experience-many-projects';
import { default as unifiedExperienceWithTfcResource } from './unified-experience-with-tfc-resource';
import { default as unifiedExperience } from './unified-experience';
import { default as usUser } from './us-user';
import { default as user } from './user';
import { default as vagrantPublic } from './vagrant-public';
import { default as vagrant } from './vagrant';
import { default as vaultClusterCommonStates } from './vault-cluster-common-states';
import { default as vaultDayZero } from './vault-day-zero';
import { default as vaultRadar } from './vault-radar';
import { default as vault } from './vault';
import { default as viewer } from './viewer';
import { default as waypointContributorPermissions } from './waypoint.contributor-permissions';
import { default as waypointEmptyState } from './waypoint.empty-state';
import { default as waypointEmptyViewer } from './waypoint.empty-viewer';
import { default as waypoint } from './waypoint';
import { default as waypointViewerPermissions } from './waypoint.viewer-permissions';
import { default as webhooksViewer } from './webhooks-viewer';
import { default as webhooks } from './webhooks';
import { default as workloadIdentityProviderZeroState } from './workload-identity-provider-zero-state';
import { default as workloadIdentityProvider } from './workload-identity-provider';
import { default as zeroHvnRoutes } from './zero-hvn-routes';
import { default as zeroHvns } from './zero-hvns';
import { default as zeroNetworkConnections } from './zero-network-connections';
import { default as zeroStateConsulClusters } from './zero-state-consul-clusters';

export default {
  awsAzurePeerings: awsAzurePeerings,
  awsPeerings: awsPeerings,
  awsQuickCreatePeerings: awsQuickCreatePeerings,
  azurePeeringsNoRoutes: azurePeeringsNoRoutes,
  azurePeeringsZeroState: azurePeeringsZeroState,
  azurePeerings: azurePeerings,
  billingEntitlementFlexTransition: billingEntitlementFlexTransition,
  billingEntitlementWithCreditCard: billingEntitlementWithCreditCard,
  billingEntitlementZeroUsage: billingEntitlementZeroUsage,
  billingEntitlement: billingEntitlement,
  billingExpiredCreditCard: billingExpiredCreditCard,
  billingFlex100Projects: billingFlex100Projects,
  billingFlexAddOns: billingFlexAddOns,
  billingFlexContractExpiredDepletedNoRenewal:
    billingFlexContractExpiredDepletedNoRenewal,
  billingFlexContractExpiredDepletedUpcomingRenewal:
    billingFlexContractExpiredDepletedUpcomingRenewal,
  billingFlexContractExpiredUpcomingRenewal:
    billingFlexContractExpiredUpcomingRenewal,
  billingFlexContractExpired: billingFlexContractExpired,
  billingFlexContractExpiringSoon: billingFlexContractExpiringSoon,
  billingFlexDepletedBalancePartialAddOn:
    billingFlexDepletedBalancePartialAddOn,
  billingFlexFirstMonth: billingFlexFirstMonth,
  billingFlexLowBalance: billingFlexLowBalance,
  billingFlexRecentAddOns: billingFlexRecentAddOns,
  billingFlexRecentlyActivatedRenewalAndRecentAddons:
    billingFlexRecentlyActivatedRenewalAndRecentAddons,
  billingFlexRecentlyActivatedRenewal: billingFlexRecentlyActivatedRenewal,
  billingFlexUpcomingRenewalAndRecentAddons:
    billingFlexUpcomingRenewalAndRecentAddons,
  billingFlexUpcomingRenewalDepletedBalance:
    billingFlexUpcomingRenewalDepletedBalance,
  billingFlexUpcomingRenewal: billingFlexUpcomingRenewal,
  billingFlexZeroBalance: billingFlexZeroBalance,
  billingFlexZeroUsage: billingFlexZeroUsage,
  billingFlex: billingFlex,
  billingOnDemandFlexTransition: billingOnDemandFlexTransition,
  billingOnDemandLowCredits: billingOnDemandLowCredits,
  billingOnDemandZeroCredits: billingOnDemandZeroCredits,
  billingOnDemandZeroUsage: billingOnDemandZeroUsage,
  billingOnDemand: billingOnDemand,
  billingTrialFlexTransition: billingTrialFlexTransition,
  billingTrialLowCredits: billingTrialLowCredits,
  billingTrialZeroCredits: billingTrialZeroCredits,
  boundaryUpdatingClusterFailed: boundaryUpdatingClusterFailed,
  boundaryUpdatingCluster: boundaryUpdatingCluster,
  boundary: boundary,
  consulAgentless: consulAgentless,
  consulClusterPeering: consulClusterPeering,
  consulFederation: consulFederation,
  consulSnapshots: consulSnapshots,
  consulTrialActive: consulTrialActive,
  consulTrialExpired: consulTrialExpired,
  consulTrialIneligible: consulTrialIneligible,
  consulTrialQuotaReached: consulTrialQuotaReached,
  consul: consul,
  consulAzure: consulAzure,
  consulClusterSizes: consulClusterSizes,
  consulClusterTiers: consulClusterTiers,
  consulDelinquent: consulDelinquent,
  consulFcp: consulFcp,
  consulGnm: consulGnm,
  consulObservability: consulObservability,
  consulObservabilityViewer: consulObservabilityViewer,
  consulReadOnlyMode: consulReadOnlyMode,
  consulViewer: consulViewer,
  contributor: contributor,
  default: defaultModule,
  freshStart: freshStart,
  groupManagerEnabled: groupManagerEnabled,
  hashicorpSsoConfigured: hashicorpSsoConfigured,
  hogwarts: hogwarts,
  hvnHvnFederatedPeeringNoDependencies: hvnHvnFederatedPeeringNoDependencies,
  hvnHvnFederatedPeering: hvnHvnFederatedPeering,
  logs: logs,
  monitoring: monitoring,
  multiHvnsAwsAndAzure: multiHvnsAwsAndAzure,
  multiHvnsDifferentRegions: multiHvnsDifferentRegions,
  multiHvnsUnsupportedRegions: multiHvnsUnsupportedRegions,
  multiHvns: multiHvns,
  navLongNames: navLongNames,
  networkConnectionsActive: networkConnectionsActive,
  networkConnectionsExpired: networkConnectionsExpired,
  networkConnectionsFailed: networkConnectionsFailed,
  networkConnectionsRejected: networkConnectionsRejected,
  newUserWithoutInvite: newUserWithoutInvite,
  noActiveSessions: noActiveSessions,
  noBillingAccount: noBillingAccount,
  noOwnedOrgsNoCreditCard: noOwnedOrgsNoCreditCard,
  noOwnedOrgs: noOwnedOrgs,
  noRoleMultipleOrgs: noRoleMultipleOrgs,
  noRoleNoProjects: noRoleNoProjects,
  noRole: noRole,
  noServicePrincipals: noServicePrincipals,
  oidcSsoConfigured: oidcSsoConfigured,
  packerPlus: packerPlus,
  packerViewer: packerViewer,
  packer: packer,
  readonlyBillingPermissions: readonlyBillingPermissions,
  samlSsoConfigured: samlSsoConfigured,
  scimEnabled: scimEnabled,
  secretsContributorPermissions: secretsContributorPermissions,
  secrets: secrets,
  'secrets.plusTier': secretsPlusTier,
  'secrets.standardTier': secretsStandardTier,
  unifiedExperienceManyProjects: unifiedExperienceManyProjects,
  unifiedExperienceWithTfcResource: unifiedExperienceWithTfcResource,
  unifiedExperience: unifiedExperience,
  usUser: usUser,
  user: user,
  vagrantPublic: vagrantPublic,
  vagrant: vagrant,
  vaultClusterCommonStates: vaultClusterCommonStates,
  vaultDayZero: vaultDayZero,
  vaultRadar: vaultRadar,
  vault: vault,
  viewer: viewer,
  'waypoint.contributorPermissions': waypointContributorPermissions,
  'waypoint.emptyState': waypointEmptyState,
  'waypoint.emptyViewer': waypointEmptyViewer,
  waypoint: waypoint,
  'waypoint.viewerPermissions': waypointViewerPermissions,
  webhooksViewer: webhooksViewer,
  webhooks: webhooks,
  workloadIdentityProviderZeroState: workloadIdentityProviderZeroState,
  workloadIdentityProvider: workloadIdentityProvider,
  zeroHvnRoutes: zeroHvnRoutes,
  zeroHvns: zeroHvns,
  zeroNetworkConnections: zeroNetworkConnections,
  zeroStateConsulClusters: zeroStateConsulClusters,
};
